import { render, staticRenderFns } from "./ClaimCreditsBox.vue?vue&type=template&id=f59398e0&"
import script from "./ClaimCreditsBox.vue?vue&type=script&lang=js&"
export * from "./ClaimCreditsBox.vue?vue&type=script&lang=js&"
import style0 from "./ClaimCreditsBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports